// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 100 101"
    {...props}
  >
    <path fill="#fff" d="M0 0H100V100H0z" transform="translate(0 .125)" />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.443}
      d="M27.8281 70.1367 35.1735 70.1343 37.442 46.0189 36.4806 40.0636M40.452 24.3198 30.1443 28.9056 27.8281 70.1367"
    />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.443}
      d="M34.5547 77.6523H47.1138L49.8575 68.0067V46.9428L40.4476 24.319M59.8828 24.3198 68.8053 29.8573 71.8935 70.1367 64.5481 70.1343 62.2784 46.0189 63.241 40.0636M63.9504 77.6523H52.6018L49.8594 68.0067M59.8884 24.3191 52.7812 39.7734M35.1692 70.1335 34.5547 77.6523"
    />
    <path
      stroke="#9FA5AB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.443}
      d="M35.8828 26.3295 41.529 39.2734 46.5583 38.9925M63.6487 26.6569 57.8046 40.0553 52.7753 39.7744 55.6436 44.8036 49.8594 56.3672M47.9609 30.7305H51.7576M47.9621 32.0484 46.3203 38.4336M51.7578 32.0484 53.3996 38.4336"
    />
  </svg>
);
const IconOvercoatOutline = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconOvercoatOutline;
